export default __webpack_public_path__ + "static/media/blue7.e89d2d0c.png";